<script>

	import { toast } from "bulma-toast"
	import { usersStore, userStore } from "../stores"

    import FacturamaService from '../$services/facturama.services'

	import ZipcodeColonyComponent from '../locations/component.zipcode.colony.svelte'

	import Form from '../$components/form.svelte'
	import InputText from '../$components/input.text.svelte'
	import ButtonSave from '../$components/button.save.svelte'

    let loading = false
    const data = {location: {}}

     
	async function createClient() {

        data.userId = $userStore._id

		loading = true;
		const resp = await FacturamaService.createClient(data);
		loading = false;

		if(!resp.success)
			toast({message: resp.error.message, type: "is-danger" });

        usersStore.replace(resp.data)
        userStore.set(resp.data)
	}

</script>

<div class="subtitle is-5">Datos de facturación</div>

<Form on:submit={createClient} { loading }>

	<InputText bind:value={data.name} label="Nombre" placeholder="Nombre" />
	
	<div class="columns">
		<div class="column">
			<InputText bind:value={data.rfc} label="RFC" placeholder="RFC" />
		</div>
		<div class="column">
			<div class="field">
				<label for="" class="label">Correo</label>
				<div class="control">
					<input
						bind:value={data.email}
						type="email"
						class="input"
						placeholder="Correo electronico"
						required
					/>
				</div>
			</div>
		</div>
	</div>

	<ZipcodeColonyComponent
		bind:zipcode={data.location.zipcode}
		bind:state={data.location.state}
		bind:city={data.location.city}
		bind:municipality={data.location.municipality}
		bind:colony={data.location.colony}
	/>
	
	<InputText bind:value={data.location.street} label="Calle" placeholder="Calle" />

	<div class="columns">
		<div class="column">
			<InputText bind:value={data.location.number} label="Número" placeholder="Número" />
		</div>
		<div class="column">
			<InputText bind:value={data.location.apartment} label="Apartamento" placeholder="Apartamento" required={false} />
		</div>
	</div>

	<div class="is-flex is-justify-content-flex-end is-align-items-center">
		<ButtonSave icon="plus" text="Crear" { loading } />
	</div>

</Form>